// Desk mode (`/c/{slug}/desk`; design spec §5, Phase 4; SHELL-DECISIONS 2026-10-30: Home was
// renamed Desk, and every old `/c/{slug}/home[/…]` URL redirects here): the first landing for
// owners, admins, agency operators and (MEMBER-UX) plain members, whose Desk is personal only.
// `core`, so it exists whatever add-ons are on. The screen keeps its internal name (HomeScreen).
import { createRoute } from "@tanstack/react-router";
import { HomeScreen } from "../features/home/home-screen";
import { useCompany } from "../features/use-feature";
import { ModeGate } from "../shell/mode-gate";
import { companyRoute } from "./c.$slug";

export const deskRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "desk",
  component: function Desk() {
    const { api } = deskRoute.useRouteContext();
    const company = useCompany();
    return (
      <ModeGate modeKey="desk">
        {/* HOME-DASH: one Desk per company (edit mode and the old checklist flag are its own). */}
        <HomeScreen key={company.id} api={api} company={company} />
      </ModeGate>
    );
  },
});
